export default __webpack_public_path__ + "static/media/loading.7cc72a9a.gif";